/* ===== AVENTUSCOPE — Tiroir panier : API panier native ===== */
(function () {
  'use strict';

  var SECTION_ID = 'aventuscope-cart-drawer';
  var TIMER_KEY = 'av_cart_deadline';
  var timerHandle = null;

  function el() { return document.querySelector('[data-av-drawer]'); }

  /* ---------- Ouverture / fermeture ---------- */
  function open() {
    var d = el(); if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    var d = el(); if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  function setLoading(s) {
    var d = el(); if (d) d.classList.toggle('is-loading', !!s);
  }

  /* ---------- Compte a rebours, persiste entre les pages ---------- */
  function startTimer() {
    var d = el(); if (!d) return;
    var span = d.querySelector('[data-av-timer]');
    if (!span) return;

    var minutes = parseInt(d.getAttribute('data-countdown'), 10);
    if (!minutes || minutes <= 0) return;

    var deadline = parseInt(sessionStorage.getItem(TIMER_KEY), 10);
    if (!deadline || isNaN(deadline) || deadline < Date.now()) {
      deadline = Date.now() + minutes * 60 * 1000;
      sessionStorage.setItem(TIMER_KEY, String(deadline));
    }

    if (timerHandle) clearInterval(timerHandle);
    function tick() {
      var live = el();
      var target = live && live.querySelector('[data-av-timer]');
      if (!target) { clearInterval(timerHandle); return; }
      var left = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
      var m = String(Math.floor(left / 60)).padStart(2, '0');
      var s = String(left % 60).padStart(2, '0');
      target.textContent = m + ':' + s;
    }
    tick();
    timerHandle = setInterval(tick, 1000);
  }

  /* ---------- Cadeau automatique ---------- */
  function giftConfig() {
    var d = el(); if (!d) return null;
    var variant = d.getAttribute('data-gift-variant');
    var threshold = parseInt(d.getAttribute('data-gift-threshold'), 10);
    if (!variant || !threshold || threshold <= 0) return null;
    return { variant: Number(variant), threshold: threshold };
  }

  function syncGift() {
    var cfg = giftConfig();
    if (!cfg) return Promise.resolve(false);

    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var giftKey = null, giftQty = 0, totalNoGift = 0;
      cart.items.forEach(function (i) {
        if (i.variant_id === cfg.variant) { giftKey = i.key; giftQty = i.quantity; }
        else { totalNoGift += i.final_line_price; }
      });
      var eligible = totalNoGift >= cfg.threshold;

      if (eligible && giftQty === 0) {
        return post('/cart/add.js', { items: [{ id: cfg.variant, quantity: 1, properties: { _cadeau: 'true' } }] }).then(function () { return true; });
      }
      if (!eligible && giftQty > 0) {
        return post('/cart/change.js', { id: giftKey, quantity: 0 }).then(function () { return true; });
      }
      if (eligible && giftQty > 1) {
        return post('/cart/change.js', { id: giftKey, quantity: 1 }).then(function () { return true; });
      }
      return false;
    }).catch(function () { return false; });
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  /* ---------- Rendu ---------- */
  function render() {
    return fetch('/?section_id=' + SECTION_ID, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-av-drawer]');
        var current = el();
        if (!fresh || !current) return;
        var wasOpen = current.classList.contains('is-open');
        current.innerHTML = fresh.innerHTML;
        ['data-gift-variant', 'data-gift-threshold', 'data-countdown'].forEach(function (a) {
          if (fresh.hasAttribute(a)) current.setAttribute(a, fresh.getAttribute(a));
        });
        if (wasOpen) current.classList.add('is-open');
        updateBubble();
        startTimer();
      })
      .catch(function (e) { console.warn('[av-cart] render', e); });
  }

  function refresh() { return syncGift().then(render); }

  function updateBubble() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('.cart-bubble__text, [data-cart-count], .cart-count-bubble span')
        .forEach(function (n) { n.textContent = cart.item_count; });
    }).catch(function () {});
  }

  /* ---------- Actions ---------- */
  function changeKey(key, qty) {
    setLoading(true);
    return post('/cart/change.js', { id: key, quantity: qty })
      .then(refresh).finally(function () { setLoading(false); });
  }

  function addVariant(id, qty, props) {
    setLoading(true);
    var item = { id: Number(id), quantity: qty || 1 };
    if (props) item.properties = props;
    return post('/cart/add.js', { items: [item] })
      .then(refresh).finally(function () { setLoading(false); });
  }

  /* Change la variante d'une ligne : Shopify ne sait pas le faire
     directement, on retire puis on rajoute avec la meme quantite. */
  function swapVariant(key, newVariantId, qty) {
    setLoading(true);
    return post('/cart/change.js', { id: key, quantity: 0 })
      .then(function () { return post('/cart/add.js', { items: [{ id: Number(newVariantId), quantity: qty }] }); })
      .then(refresh)
      .finally(function () { setLoading(false); });
  }

  /* Retire toutes les lignes d'un produit */
  function removeProduct(productId) {
    setLoading(true);
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var keys = cart.items.filter(function (i) { return String(i.product_id) === String(productId); })
                           .map(function (i) { return i.key; });
      return keys.reduce(function (chain, k) {
        return chain.then(function () { return post('/cart/change.js', { id: k, quantity: 0 }); });
      }, Promise.resolve());
    }).then(refresh).finally(function () { setLoading(false); });
  }

  /* Ajoute ou retire une unite sur un produit entier */
  function bumpProduct(key, dir) {
    setLoading(true);
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var line = cart.items.filter(function (i) { return i.key === key; })[0];
      if (!line) return;
      if (dir === 'plus') {
        return post('/cart/add.js', { items: [{ id: line.variant_id, quantity: 1 }] });
      }
      return post('/cart/change.js', { id: key, quantity: Math.max(0, line.quantity - 1) });
    }).then(refresh).finally(function () { setLoading(false); });
  }

  /* ---------- Evenements ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('[data-av-close]')) { e.preventDefault(); close(); return; }

    var toggle = t.closest('[data-av-toggle]');
    if (toggle) {
      e.preventDefault();
      var body = toggle.parentElement.querySelector('[data-av-variants]');
      var label = toggle.querySelector('.av-cart-drawer__toggle-label');
      var openNow = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!openNow));
      if (body) body.hidden = openNow;
      if (label) {
        var n = label.textContent.replace(/\D+/g, '');
        label.textContent = (openNow ? 'Voir les ' : 'Masquer les ') + n + ' articles';
      }
      return;
    }

    var qtyBtn = t.closest('[data-av-qty]');
    if (qtyBtn) {
      e.preventDefault();
      bumpProduct(qtyBtn.getAttribute('data-key'), qtyBtn.getAttribute('data-av-qty'));
      return;
    }

    var rmProduct = t.closest('[data-av-remove-product]');
    if (rmProduct) {
      e.preventDefault();
      removeProduct(rmProduct.getAttribute('data-av-remove-product'));
      return;
    }

    var addBtn = t.closest('[data-av-add]');
    if (addBtn) {
      e.preventDefault();
      addBtn.disabled = true;
      addBtn.textContent = 'Ajouté';
      addVariant(addBtn.getAttribute('data-av-add'), 1).then(open);
      return;
    }

    var applyBtn = t.closest('[data-av-apply]');
    if (applyBtn) {
      e.preventDefault();
      var input = el().querySelector('[data-av-code]');
      var code = input && input.value.trim();
      if (!code) return;
      /* Shopify applique les codes via cette route, puis renvoie sur la page */
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(location.pathname + '?cart=open');
      return;
    }

    var cartLink = t.closest('a[href$="/cart"], a[href*="/cart?"], [data-cart-icon], .header-actions__cart, cart-icon');
    if (cartLink) { e.preventDefault(); refresh().then(open); }
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-av-variant]');
    if (sel) {
      swapVariant(sel.getAttribute('data-key'), sel.value, parseInt(sel.getAttribute('data-qty'), 10) || 1);
      return;
    }

    var sw = e.target.closest('[data-av-warranty]');
    if (sw) {
      var vid = sw.getAttribute('data-av-warranty');
      if (sw.checked) {
        addVariant(vid, 1);
      } else {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var line = cart.items.filter(function (i) { return String(i.variant_id) === String(vid); })[0];
          if (line) changeKey(line.key, 0);
        });
      }
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    setLoading(true);
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { console.warn('[av-cart]', res.description || res.message); return; }
        return refresh().then(open);
      })
      .catch(function (err) { console.warn('[av-cart] add', err); })
      .finally(function () { setLoading(false); });
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateBubble();
    startTimer();
    syncGift().then(function (changed) { if (changed) render(); });
    if (new URLSearchParams(location.search).get('cart') === 'open') refresh().then(open);
  });

  window.avCart = { open: open, close: close, refresh: refresh };
})();
